import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService, UserStatus, LoginStatus} from '../user.service';
import {GlobalValidator} from '../global-validator';
import {Router} from '@angular/router';
import {AppSettingsService} from "../app-settings.service";

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.css']
})
export class ChangePassComponent implements OnInit {

  public changePassForm: FormGroup;
  loading = false;
  serverError = undefined;

  formErrors = {
    'password': new Array<string>(),
    'passwordConfirmation': new Array<string>()
  };

  validationMessages = {
    'password': {
      'required': 'Necessário informar a nova senha',
      'NeedNumbersAndLetters': 'A senha deve conter letras e números',
      'LengthTooSmall': 'A senha deve conter ao menos 8 caracteres',
    },
    'passwordConfirmation': {
      'required': 'Necessário confirmar a senha',
      'MatchPassword': 'As senhas não conferem'
    }
  };

  constructor(private fb: FormBuilder, private us: UserService, private router: Router, private ass: AppSettingsService) {
  }

  ngOnInit() {
    this.buildForm();
    this.changePassForm.valueChanges.debounceTime(1000)
      .subscribe((data) => this.onValueChanges(data));
    this.ass.menuState.next(false);
    this.ass.headerState.next(false);
  }

  buildForm() {
    this.changePassForm = this.fb.group({
      'password': ['', [Validators.required, GlobalValidator.complexityValidator(8, true)]],
      'passwordConfirmation': ['', Validators.required],
    }, {validator: GlobalValidator.matchPasswordValidator})
  }

  onValueChanges(data?: any) {
    const form = this.changePassForm;

    for (const field in this.formErrors) {
      // clear previous messages
      this.formErrors[field] = new Array<string>();
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          console.log(`got key ${key}`);
          this.formErrors[field].push(messages[key]);
        }
      }
    }

    for (const error in this.formErrors) {
      if (error !== '""') {
        console.log(`Error:${JSON.stringify(this.formErrors[error])}`);
      }
    }
  }

  tryChangePass(model, isValid: boolean) {
    if (!isValid) {
      console.warn(`Invalid Form received!!!:'${JSON.stringify(model)}'`)
    }
    this.loading = true;
    this.serverError = undefined;
    this.us.changePassword(this.us.currentUser.getValue(), model['password'], false)
      .subscribe(res => {
        this.loading = false;
        if (res.id === this.us.currentUser.getValue().username) {
          console.log(`Password changed successfully!!!`);
          this.us.loginStatus.next(new LoginStatus(UserStatus.LOGGED));
          this.ass.headerState.next(true)
          this.ass.menuState.next(true)
          this.router.navigateByUrl('/');
        }
      }, (error) => {
        console.log(`received error:${JSON.stringify(error)}`);
        this.loading = false;
        this.serverError = error.error.message;
      });
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/change-pass/change-pass.component.ts